<template>
  <div class="mt-3 mt-sm-5 pt-5">
    <b-container>
      <div class="psiContainer">
        <h1 class="font20 mb-4">Sitemap</h1>
        <p class="font14 text-algo-normal mb-4">
          Use this page to find links to all main sections of PortfolioSmith. You can also use the header menu or the site map links in the page footer.
        </p>

        <nav aria-label="Site pages">
          <section class="sitemap-section" aria-labelledby="sitemap-main-heading">
            <h2 id="sitemap-main-heading" class="font16 font-weight500 mb-3">Main</h2>
            <ul class="sitemap-list">
              <li><router-link :to="{ name: 'home' }">Home</router-link></li>
              <li><a href="#" @click.prevent="goToHomeSection('#features')">Features</a></li>
              <li><a href="#" @click.prevent="goToHomeSection('#pricing')">Pricing</a></li>
              <li><a href="#" @click.prevent="goToHomeSection('#partnerwithus')">Partner with Us</a></li>
            </ul>
          </section>

          <section class="sitemap-section" aria-labelledby="sitemap-about-heading">
            <h2 id="sitemap-about-heading" class="font16 font-weight500 mb-3">About &amp; support</h2>
            <ul class="sitemap-list">
              <li><router-link :to="{ name: 'about' }">History</router-link></li>
              <li><router-link :to="{ name: 'faqs' }">FAQ's</router-link></li>
              <li><router-link :to="{ name: 'contactus' }">Contact</router-link></li>
              <li><router-link :to="{ name: 'legalagreement' }">Legal Agreement</router-link></li>
              <li><router-link :to="{ name: 'privacypolicy' }">Privacy Policy</router-link></li>
            </ul>
          </section>

          <section
            v-if="!isLoggedin && !isRedirectedBrokerUrl"
            class="sitemap-section"
            aria-labelledby="sitemap-account-heading"
          >
            <h2 id="sitemap-account-heading" class="font16 font-weight500 mb-3">Account</h2>
            <ul class="sitemap-list">
              <li><router-link :to="{ name: 'login', params: { id: 'login' } }">Login</router-link></li>
              <li><router-link :to="{ name: 'login', params: { id: 'signup' } }">Sign Up</router-link></li>
              <li><router-link :to="{ name: 'forgotpassword' }">Forgot Password</router-link></li>
              <li><router-link :to="{ name: 'register' }">Register</router-link></li>
            </ul>
          </section>

          <section
            v-if="isLoggedin"
            class="sitemap-section"
            aria-labelledby="sitemap-app-heading"
          >
            <h2 id="sitemap-app-heading" class="font16 font-weight500 mb-3">Your portfolio</h2>
            <ul class="sitemap-list">
              <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
              <li><router-link :to="{ name: 'evaluation' }">Evaluate Portfolio</router-link></li>
              <li><router-link :to="{ name: 'reports' }">Reports</router-link></li>
              <li><router-link :to="{ name: 'useraccount' }">My Profile</router-link></li>
              <li v-if="userDetails.isBrokerAdminUser">
                <router-link :to="{ name: 'partnerbrokeradmin' }">Admin Dashboard</router-link>
              </li>
            </ul>
          </section>
        </nav>
      </div>
    </b-container>
  </div>
</template>

<script>
import { goToHomeSection } from '@/utils/homeSectionNav'

export default {
  methods: {
    goToHomeSection(selector) {
      goToHomeSection(this, selector);
    },
  },
  computed: {
    userDetails () {
      return this.$store.state.authentication.user
    },
    isLoggedin () {
      return !!localStorage.getItem('psitoken')
    },
    isRedirectedBrokerUrl () {
      return localStorage.getItem('utmParams') != null && localStorage.getItem('utmParams') !== undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sitemap.vue